<template>
  <div :class="['div-input', className]">
    <div class="display-only" v-if="isDisplay"></div>
    <div :class="['input-custom', { error: isValidate }]">
      <label v-if="textFloat" class="w-100 align-items-center d-flex">
        {{ textFloat }}
        <span v-if="isRequired" class="text-danger">*</span>
        <span v-if="textWarning" class="text-warning-message ml-3">{{
          textWarning
        }}</span>
        <b-button
          v-if="textTooltip"
          v-b-tooltip.hover.html.rightbottom="{ variant: 'light' }"
          :title="textTooltip"
          variant="tooltip-main"
        >
          <b-icon icon="exclamation-circle"></b-icon>
        </b-button>
        <b-button
          v-if="isCopy"
          variant="tooltip-main"
          class="ml-auto"
          @click="copyValue()"
        >
          <font-awesome-icon icon="copy" class="mb-0" />
        </b-button>
      </label>
      <input
        :class="['custom-input']"
        type="number"
        :placeholder="placeholder"
        :name="name"
        :required="required"
        :value="value"
        :readonly="readonly"
        @focus="$emit('onFocus', $event)"
        :size="size"
        @input="$emit('input', $event.target.value)"
        @change="onDataChange"
        @keyup="$emit('onKeyup', $event)"
        @keypress="$emit('onKeypress', $event)"
        :disabled="disabled"
      />
      <span v-if="suffix !== ''" class="subffix"> {{ suffix }}</span>
      <div
        v-if="isShowPassword"
        :class="['button-eye', { hastextFloat: textFloat != '' }]"
      >
        <font-awesome-icon
          v-if="passwordType == 'password'"
          @click="handleShowHidePassword"
          :icon="['fas', 'eye-slash']"
          class="pointer"
        />
        <font-awesome-icon
          v-else
          @click="handleShowHidePassword"
          :icon="['fas', 'eye']"
          class="pointer"
        />
      </div>
    </div>
    <img :src="img" alt="logo-lang" v-if="img" class="logo-lang" />
    <span v-if="detail" class="text-desc text-wrap">{{ detail }}</span>
    <div v-if="v && v.$error">
      <span class="text-error" v-if="v.required == false">{{
        $t("pleaseEnterInfo")
      }}</span>
      <span class="text-error" v-else-if="v.minLength == false"
        >{{ $t("pleaseEnterAtLeast") }} {{ v.$params.minLength.min }}
        {{ $t("characters") }}
      </span>
      <span class="text-error" v-else-if="v.integer == false"
        >{{ $t("pleaseOnlyNumber") }}
      </span>
      <span class="text-error" v-else-if="v.maxLength == false"
        >{{ $t("pleaseEnterMoreThan") }} {{ v.$params.maxLength.max }}
        {{ $t("characters") }}
      </span>
      <span class="text-error" v-else-if="v.decimal == false"
        >{{ $t("pleaseOnlyNumber") }}
      </span>
      <span class="text-error" v-else-if="v.minValue == false"
        >{{ $t("pleaseEnterNumberGreaterThan") }} {{ v.$params.minValue.min }}
      </span>
      <span class="text-error" v-else-if="v.maxValue == false"
        >{{ $t("pleaseEnterNumberLessThan") }} {{ v.$params.maxValue.max }}
      </span>
      <span class="text-error d" v-else-if="v.sameAsPassword == false"
        >{{ $t("passwordMustMatch") }}
      </span>
      <span class="text-error" v-else-if="v.validateMaxLength == false"
        >{{ $t("pleaseEnterMoreThan") }} {{ maxLength }} {{ $t("characters") }}
      </span>
      <span class="text-error" v-else-if="v.alpha == false"
        >{{ $t("pleaseLettersOnly") }}
      </span>
    </div>
  </div>
</template>

<script>
import { readonly } from "vue";

export default {
  props: {
    textFloat: {
      required: true,
      type: String,
    },
    placeholder: {
      required: true,
      type: String,
    },
    // type: {
    //   required: true,
    //   type: String,
    // },
    required: {
      required: false,
      type: Boolean,
    },
    detail: {
      required: false,
      type: String,
    },
    size: {
      required: false,
      type: String,
    },
    name: {
      required: false,
      type: String,
    },
    readonly: {
      required: false,
      type: Boolean,
      default: false,
    },
    value: {
      required: false,
      type: [String, Number],
    },
    isDisplay: {
      required: false,
      type: Boolean,
    },
    isRequired: {
      required: false,
      type: Boolean,
    },
    isValidate: {
      required: false,
      type: Boolean,
    },
    v: {
      required: false,
      type: Object,
    },
    className: {
      required: false,
      type: String,
    },
    img: {
      required: false,
      type: String,
    },
    disabled: {
      required: false,
      type: Boolean,
    },
    icon: {
      required: false,
      type: String,
    },
    maxLength: {
      required: false,
      type: Number,
    },
    isShowPassword: {
      required: false,
      type: Boolean,
    },
    textWarning: {
      required: false,
      type: String,
    },
    textTooltip: {
      required: false,
      type: String,
    },
    isCopy: {
      required: false,
      type: Boolean,
    },
    suffix: {
      required: false,
      type: String,
      default: "",
    },
  },
  data() {
    return {
      passwordType: "password",
    };
  },
  methods: {
    onDataChange(event) {
      this.$emit("onDataChange", event.target.value);
    },
    handleShowHidePassword() {
      if (this.passwordType == "password") {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
    },
    copyValue() {
      navigator.clipboard.writeText(this.value);
    },
  },
};
</script>

<style scoped>
.div-input {
  margin-bottom: 15px;
  position: relative;
  white-space: nowrap;
}
.input-custom {
  padding: 0px;
  position: relative;
}
.input-custom > label {
  color: #404040;
  font-size: 16px;
  margin-bottom: 2px;
  font-weight: bold;
}
.input-custom > input {
  color: #404040;
  /* background-color: white; */
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  padding: 5px 10px;
}
.input-custom > input[size="lg"] {
  height: 45px;
}
.input-custom > input:focus {
  border: 1px solid #242424;
}
.input-custom.error > input {
  border-color: red !important;
}
::-webkit-input-placeholder {
  /* Edge */
  color: rgba(36, 36, 36, 0.4);
}
:-ms-input-placeholder {
  /* Internet Explorer */
  color: rgba(36, 36, 36, 0.4);
}
::placeholder {
  color: rgba(36, 36, 36, 0.4);
}
.custom-input {
  display: block;
  border: none;
  width: 100%;
}
.text-desc {
  color: #9b9b9b;
  font-size: 12px;
}
.display-only {
  position: absolute;
  z-index: 5000;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.text-error {
  color: #ff0000;
  font-size: 14px;
}
.d-grid {
  display: grid;
}
.button-eye {
  position: absolute;
  right: 20px;
  bottom: 1rem;
  z-index: 6;
}
.hastextFloat {
  bottom: 1rem;
}
.text-warning-message {
  color: #bebebe;
  font-size: 12px;
}
.btn-tooltip-main {
  padding: 0 0 0 4px;
}
.btn-tooltip-main svg {
  width: 13px;
  height: 13px;
  margin-bottom: 5px;
  color: #5b57a5;
}
.subffix {
  position: absolute;
  right: 0.75rem;
  top: 67%;
  transform: translateY(-50%);
  color: #9ca3af;
  padding-left: 0.75rem;
  margin-left: 0.75rem;
}

.subffix::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 100%;
  background-color: #d1d5db;
}
@media (max-width: 767.98px) {
  /* .div-input {
    margin-top: 0;
  } */
  .input-custom > label {
    font-size: 15px;
  }
}
</style>
